<template>
  <div>
    <PageAppBar>Farming</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div v-if="!Object.keys(projects).length">
        <mushonga></mushonga>
      </div>
      <div v-else-if="!projects.data">
        No stands projects registered so far.
      </div>
      <div v-else v-for="project in projects.data.data" :key="(project.id)">
        <div>
          <div class="card card-style mb-3">
            <div class="d-flex">
              <div class="pl-3 ml-2 align-self-center">
                <h1 class="pt-4">{{ project.project }}</h1>
                <p class="font-11 opacity-50 mt-n2 mb-2">Description: {{ project.details }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Payment Interval: {{ project.contribution_interval }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Duration: {{ project.number_of_contributions }} {{ project.contribution_interval }}s</p>
                <p @click="joinProject(project)" class="font-11 opacity-50 mt-n2 mb-4">Join scheme</p>
                <router-link :to="'/projects/'+project.id"  class="font-11 opacity-50 mt-n2 mb-4">More Details</router-link>
              </div>
              <div class="ml-auto mr-4 align-self-center">
                <i @click="joinProject(project)" class="fa fa-plus-circle color-blue2-dark fa-3x mt-4 mb-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
    <div v-else-if="message.length" class="page-content header-clear-small">
      <div v-if="message.length">
        {{message}}
      </div>
      <div class="card card-style">
        <div class="content">
          <h1>TBD FARMING</h1>
          <p class="color-highlight font-12 mt-n3 pt-1 mb-2">You have joined TFP{{project.id}}</p>
          <p v-if="Object.keys(project).length">To begin you have to start making your contributions of ${{project.contribution_amount}}
            starting {{project.start_date}} for {{project.number_of_contributions}} {{project.contribution_interval}}s </p>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import global from "@/mixins/global";
import axios from "axios";
export default {
  mounted() {
    axios.get(this.base_url+"farming", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{this.projects = response}).catch(error=>{this.error = error})
  },
  mixins: [global],
  data(){
    return {
      projects: [],
      project: {}
    }
  },
  name: "Farming",
  components: {PageAppBar, FooterBar},
  methods: {
    joinProject(project){
      this.project = project
      axios.post(this.base_url+"farming/join/"+project.id,{},
          this.requestAuthHeaderToken(localStorage.getItem("token")
          )).then(response=>{
        this.message = response.data.message
      }).catch(error=>{
        this.error = error
      })
    }
  }
}
</script>

<style scoped>

</style>